<template>
  <div v-if="loading" class="global-loader">
    <div class="spinner"></div>
  </div>
</template>

<script setup>
import { useLoaderStore } from '@/stores/loader';
import { computed, onUnmounted, watch } from 'vue';
const loader = useLoaderStore();
const loading = computed(() => loader.loading);

// Watch and toggle body scroll
watch(loading, (val) => {
  document.body.classList.toggle('no-scroll', val);
});

onUnmounted(() => {
  document.body.classList.remove('no-scroll');
});
</script>

<style scoped>
:root {
  --gradiant-1: linear-gradient(109deg, #725CFF 4.97%, #41B9FE 95.65%);
}

.global-loader {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Spinner with gradient background */
.spinner {
  width: 50px;
  height: 50px;
  border: 6px solid transparent;
  border-top: 6px solid;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  background-image: var(--gradiant-1, linear-gradient(109deg, #725CFF 4.97%, #41B9FE 95.65%));
  background-clip: border-box;
  -webkit-mask: 
    radial-gradient(farthest-side, transparent calc(100% - 6px), black calc(100% - 5px));
  -webkit-mask-composite: destination-in;
  mask-composite: intersect;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>